import { EyeIcon } from 'assets/icons';
import Button from 'components/button';
import useOpenInvoiceDetail from 'components/invoiceDetail/useOpenInvoiceDetail';
import { fillText } from 'components/invoiceImport/invoiceImportText';
import UseContext from 'hooks/useContext';
import { formatEuros } from './invoiceAmount';
import InvoiceStatusBadge from './InvoiceStatusBadge';

export { formatEuros };

export const CHECKBOX_CLASS_NAME =
  'w-4 h-4 align-middle cursor-pointer accent-yellow-400';

/**
 * One invoice of the month list (JBWEB-1269), with its box (JBWEB-1273): in
 * the flat list, and under an unfolded row of the grouped one (JBWEB-1309),
 * where `isSelectionLocked` greys the box while the row box reads. The eye
 * opens the detail of the invoice (JBWEB-1274), whatever its status: a
 * discovered one shows its PDF read live from BeSTT.
 */
const InvoiceRow = ({ invoice, isSelected, onToggle, isSelectionLocked }) => {
  const { language } = UseContext();
  const openInvoiceDetail = useOpenInvoiceDetail();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);

  // An invoice whose BeSTT client matches no company, or several, is named by
  // that client.
  const companyLabel = () => {
    if (invoice.companyName) return invoice.companyName;
    if (invoice.besttClientId != null) {
      return fillText(text('besttClient', 'Client Bestt {id}'), {
        id: invoice.besttClientId,
      });
    }
    return '—';
  };

  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50">
      <td className="py-3 pl-4 pr-2 w-px">
        <input
          type="checkbox"
          className={CHECKBOX_CLASS_NAME}
          checked={isSelected}
          disabled={isSelectionLocked}
          onChange={() => onToggle(invoice)}
          aria-label={fillText(
            text('selection.selectInvoice', 'Sélectionner la facture {number}'),
            { number: invoice.number },
          )}
        />
      </td>
      <td className="px-2 py-3 whitespace-nowrap">{invoice.number}</td>
      <td className="px-2 py-3">{companyLabel()}</td>
      <td className="px-2 py-3 whitespace-nowrap">
        {formatEuros(invoice.amountInclTax)}
      </td>
      <td className="px-2 py-3 whitespace-nowrap">
        {invoice.remainingAmount == null ? (
          <span className="text-gray-400">-</span>
        ) : (
          formatEuros(invoice.remainingAmount)
        )}
      </td>
      <td className="px-2 py-3">
        <InvoiceStatusBadge invoice={invoice} />
      </td>
      <td className="py-3 pl-2 pr-3">
        <div className="flex justify-end items-center">
          <Button
            color="TABLE"
            size="TABLE"
            aria-label={text('viewInvoice', 'Voir la facture')}
            onClick={() => openInvoiceDetail(invoice.number)}
          >
            <EyeIcon wh={20} />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default InvoiceRow;
